import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ExternalLink } from "lucide-react";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { isoToDisplayDateTime } from "./DateInput";

export const PerubahanKhususCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/kondisi/perubahan-khusus", { params: { hari: 7 } }).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const ada = d.items.length > 0;
  return (
    <Card className={`p-4 sm:p-5 rounded-2xl ${ada ? "border-red-300 bg-red-50/60" : "border-slate-200/80"}`} data-testid="dashboard-perubahan-khusus-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="h-11 w-11 rounded-xl bg-red-100 text-red-700 flex items-center justify-center shrink-0"><AlertTriangle className="h-5 w-5" /></div>
          <div className="min-w-0"><div className="text-xs sm:text-sm text-slate-600">🔴 Perubahan ke Perlu Perhatian Khusus · 7 hari terakhir</div>
            <div className="text-xl sm:text-2xl font-bold text-slate-900"><span data-testid="dashboard-perubahan-khusus-count">{d.total}</span> Perubahan</div></div>
        </div>
        <Link to="/kondisi-anggota?status=Perlu%20Perhatian%20Khusus" className="text-sm font-semibold text-[hsl(224,64%,33%)] hover:underline min-h-[44px] inline-flex items-center" data-testid="dashboard-perubahan-khusus-link">Lihat Member Monitoring →</Link>
      </div>
      {ada ? (
        <ul className="mt-3 divide-y divide-red-100" data-testid="dashboard-perubahan-khusus-list">
          {d.items.slice(0, 5).map((it) => (
            <li key={it.id} className="py-2 flex flex-wrap items-start justify-between gap-2" data-testid={`dashboard-perubahan-khusus-${it.id}`}>
              <div className="min-w-0 flex-1">
                <Link to={`/jemaat/${it.jemaat_id}`} className="font-semibold text-slate-900 hover:underline">{it.nama_lengkap}</Link>
                <span className="text-xs font-mono text-slate-500 ml-2">{it.nij}{it.care_leader ? ` · CL: ${it.care_leader}` : ""}</span>
                {it.catatan && <div className="text-sm text-slate-700 line-clamp-2">{it.catatan}</div>}
                <div className="text-xs text-slate-500">{isoToDisplayDateTime(it.waktu)} · oleh {it.oleh}{it.status_lama ? ` · sebelumnya: ${it.status_lama}` : ""}</div>
              </div>
              {it.status_kini && it.status_kini !== "Perlu Perhatian Khusus" && <Badge variant="outline" className="bg-emerald-50 text-emerald-700 border-emerald-200 text-xs">Kini: {it.status_kini}</Badge>}
            </li>
          ))}
          {d.items.length > 5 && <li className="pt-2 text-xs text-slate-500">+{d.items.length - 5} perubahan lainnya</li>}
          <li className="pt-3"><a href={d.link_pastoral} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-semibold text-red-700 hover:underline min-h-[44px]" data-testid="dashboard-perubahan-khusus-pastoral"><ExternalLink className="h-4 w-4" /> Ajukan Pelayanan Pastoral (pilih Jenis Pelayanan: Konseling Pastoral)</a></li>
        </ul>
      ) : <div className="mt-2 text-sm text-slate-500" data-testid="dashboard-perubahan-khusus-kosong">Tidak ada anggota yang berubah menjadi 🔴 dalam 7 hari terakhir.</div>}
    </Card>
  );
};
